<template>
  <div id="header">
    <v-app-bar dense>

      <router-link style="text-decoration: none !important;" to="/">
        <v-app-bar-title style="cursor: pointer; color: #2c3e50 !important;" > OceanWallet</v-app-bar-title>
      </router-link>

      <div id="nav">
        <router-link style="text-decoration: none" to="/">Home</router-link>
        |
        <router-link style="text-decoration: none" :to="'/inventory/' + selectedTable.symbol + '/' +  user">Inventory</router-link>
        |
        <router-link style="text-decoration: none" :table="selectedTable.symbol" :to="'/market/' + selectedTable.symbol">Market</router-link>
        |
        <router-link style="text-decoration: none" to="/about">About</router-link>
      </div>

      <div class="appBarContainer">
<!--        TODO: Make sure that if you directly access e.g. the CROPS page that this gets properly updated-->
        <v-select
            @change="switchTable"
            style="margin-top: 20px;"
            v-model="selectedTable"
            :items="tables"
            item-text="fullName"
            item-value="symbol"
            label="Project"
            return-object
            single-line
        ></v-select>
      </div>

      <v-spacer/>

      <div id="loginArea" v-if="user === null">
        <v-text-field @keyup.enter="keychainLogin(usernameInput)" style="margin-top: 5px" placeholder="Enter username" v-model="usernameInput"></v-text-field>
        <v-btn @click="keychainLogin(usernameInput)">Login</v-btn>
      </div>
      <div v-else class="appBarContainer">
        <span v-if="user">Hello, {{ user }}</span>
        <v-btn @click="logout">
          Logout
        </v-btn>
      </div>

    </v-app-bar>
  </div>
</template>

<script>


export default {
  name: 'Header',
  created() {
    window.addEventListener("load", () => {
      const lastLoginName = localStorage.getItem("lastUsername");
      if (lastLoginName && lastLoginName !== "") {
        this.keychainLogin(lastLoginName);
      }
    });
  },
  mounted() {
    // TODO: Make this work
    const params = this.$route.params;
    // TODO: Should probably use symbol for both instead of table
    if (params.symbol || params.table) {
      this.$store.commit('changeTable', params.symbol ? params.symbol : params.table);
    }
  },
  computed: {
    selectedTable: {
      get () {
        return this.$store.state.selectedTable;
      },
      set (value) {
        this.$store.commit('changeTable', value);
      }
    },
    user: {
      get() {
        return this.$store.state.user
      },
      set(value) {
        this.$store.commit('changeUser', value);
      }
    }
  },
  methods: {
    checkUsername() {
      if (this.user == null || this.user === "null") {
        let input = prompt('Please enter a username');
        if (input === "") {
          input = "null"
        }

        this.$router.push('/inventory/' + input).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
            console.log(err);
          }
        });
      }
    },
    keychainLogin(account) {
      // eslint-disable-next-line no-undef
      hive_keychain.requestSignBuffer(account, "login", "Posting", (res) => {
        if(res.success === true) {
          this.user = res.data.username;
          localStorage.setItem("lastUsername", account);
        }
        else {
          alert("Failed to login. Please check that all inputs are valid")
        }
      });
    },
    logout() {
      this.user = null;
      this.usernameInput = "";
      localStorage.setItem("lastUsername", "");
    },
    switchTable() {
      const currentRoute = this.$router.currentRoute;
      if (currentRoute.name === "Market") {
        this.$router.replace("/market/" + this.selectedTable.symbol );
      }
      else if (currentRoute.name === "Inventory") {
        this.$router.replace("/inventory/" + this.selectedTable.symbol + "/" +  this.user)
      }
    }
  },
  data() {
    return {
      usernameInput: "",
      tables: [
        { symbol: 'STAR', fullName: 'Rising Star' },
        { symbol: 'DCROPS', fullName: 'dCrops' },
      ]
    }
  }
}
</script>

<style scoped>
#loginArea {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 5px;
  margin-top: 17px;
}

.appBarContainer {
  display: grid;
  grid-gap: 5px;
  grid-auto-flow: column;
  align-items: center
}
</style>
